import { useEffect, useState } from "react";
import Icon from "@mdi/react";
import { mdiPlus } from "@mdi/js";
import { useRouter } from "easy-page-router";
import { Link } from "easy-page-router/react";
import { useSSRHook } from "ssr-hook";


import { Footer, Header } from "../../Layout";
import { useHead } from "../../services/common";
import { Loading, Page } from "../../components";
import { ThemeDiv, ThemeSwitch } from "../../components/Theme";
import { LangSwitch } from "../../components/Lang";
import { useLang } from "../../services/lang";
import { api, handleError, useHandleError } from "../../services/api";

import { UserInput, useUser } from "../../components/User";
import Dialog from "../../components/Dialog";
import { EditTeam } from "./components/EditTeam";
import { getTeamUrl } from "./components/TeamSelect";

import { ID, TeamPreview } from "../../../types";


export default function TeamBoard() {
    const { push } = useRouter();
    const { lang, dict } = useLang();
    const { userId, isLoggedIn, showUserDialog } = useUser();

    useHead({
        title: dict.seo.teamBoard.title,
        description: dict.seo.teamBoard.description,
    });

    const [teams, setTeams] = useState<TeamPreview[]>([]);
    const [error, setError] = useState<null | string>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [reload, setReload] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        api.getTeamPreviews({ userId }).then(([teams, error]) => {
            // TODO: is component mounted?
            if (error) {
                handleError(error);
                setError(error);
            } else if (teams) {
                setTeams(teams);
            }
            setIsLoading(false);
        });
    }, [userId, reload]);


    const [editTeam, setEditTeam] = useState<null | TeamPreview>(null);

    function handleNewTeam() {
        if (!isLoggedIn)
            showUserDialog();

        setEditTeam({
            _id: "",
            lang,
            title: "",
            description: "",
            theme: "",
        });
    }

    function handleAddTeam(id: ID) {
        push(getTeamUrl(lang, id));
        setEditTeam(null);
        setReload(r => r + 1);
    }

    return <Page fixed={<>
        <Header title={dict.team} link={`/${dict.urlTeam}`}>
            <LangSwitch />
            <ThemeSwitch />
        </Header>
        <Footer />
    </>}>
        <div className={`full-page team`}>
            <h1>{dict.team} <span className="sub-title">{dict.teamSubTitle}</span></h1>

            <p className="page-description">{dict.seo.teamBoard.text}</p>

            <a className="button-new" onClick={handleNewTeam}><Icon path={mdiPlus} size={1} /> {dict.teamCreate}</a>
            {isLoggedIn && <UserInput />}
            {!isLoggedIn && <p className="info">{dict.teamLogIn[0]}<a className="block" style={{ padding: "0px 8px" }} onClick={showUserDialog}>{dict.teamLogIn[1]}</a>.</p>}

            <h3 style={{ paddingTop: 30, paddingBottom: 20 }}>{dict.teamListTitle}</h3>
            {isLoading && <Loading />}
            {error && <p className="error">{dict.teamError}</p>}
            {teams && teams.length === 0 && <p className="info">{dict.teamEmpty}</p>}
            {teams && teams.length > 0 && <>
                <div className="grid">
                    {teams.map(team => <Link key={team._id} href={getTeamUrl(lang, team._id)}>
                        <ThemeDiv
                            key={team._id}
                            theme={team.theme}
                            className="poll-preview grid-item"
                        >
                            <h3 className="line-clamp-2">{team.title}</h3>
                            <p className="pre-line line-clamp-3">{team.description}</p>
                        </ThemeDiv>
                    </Link>)}
                </div>
            </>}

            {/* Edit team */}
            {isLoggedIn && <Dialog show={!!editTeam} onClose={() => setEditTeam(null)}>
                {editTeam && <EditTeam {...editTeam} onSuccess={handleAddTeam} />}
            </Dialog>}
        </div>
    </Page >;
}
